import { useEffect } from "react";

// Add global type for adsbygoogleLoaded
declare global {
  interface Window {
    adsbygoogleLoaded?: boolean;
  }
}

export function GoogleAdsScriptLoader({ enabled, publisherId }: { enabled: boolean, publisherId: string }) {
  console.log('[App] GoogleAdsScriptLoader entry : flag status is :', enabled, 'publisherId:', publisherId);
  useEffect(() => {
    if (enabled !== true) {
      // If feature is not enabled, remove the script if it exists
      const scriptId = "google-adsbygoogle-script";
      const script = document.getElementById(scriptId);
      if (script) {
        script.parentNode?.removeChild(script);
        window.adsbygoogleLoaded = false;
        console.log("[App]: Google AdSense script removed because feature is disabled.");
      }
      return;
    }
    const scriptId = "google-adsbygoogle-script";
    let script: HTMLScriptElement | null = document.getElementById(scriptId) as HTMLScriptElement | null;

    // Listen for forced reload event from any component
    function handleForceReload() {
      if (script) {
        script.parentNode?.removeChild(script);
        console.log("[App]: Forced reload of AdSense script");
      }
      script = document.createElement("script");
      script.id = scriptId;
      script.async = true;
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${publisherId}`;
      script.crossOrigin = "anonymous";
      script.setAttribute('data-google-ads', 'true');
      script.onload = () => {
        window.adsbygoogleLoaded = true;
        console.log("[App]: ✅ Google AdSense script loaded successfully.");
        // Dispatch a custom event for listeners
        window.dispatchEvent(new Event('adsbygoogleScriptLoaded'));
      };
      script.onerror = (err) => {
        window.adsbygoogleLoaded = false;
        console.error("[App]: ❌ Failed to load Google AdSense script.", err);
      };
      document.head.appendChild(script);
    }
    window.addEventListener('forceReloadAdsbygoogleScript', handleForceReload);

    // If script is missing or adsbygoogleLoaded is false, reload the script
    if (!script || window.adsbygoogleLoaded === false) {
      handleForceReload();
    } else {
      // If script is present, check if it's loaded
      if (window.adsbygoogleLoaded) {
        console.log("[App]: ℹ️ Google AdSense script already loaded.");
      } else {
        console.log("[App]: ℹ️ Google AdSense script already exists, waiting for load event.");
      }
    }
    return () => {
      window.removeEventListener('forceReloadAdsbygoogleScript', handleForceReload);
    };
  }, [enabled, publisherId]);

  return null;
}
